<template>
  <div :style="styles.base">
    <div v-if="bindClubId || isInEditor" :style="clubCardStyle" :class="getCss('club-card')">
      <div :class="getCss('club-card-text')" v-if="judgeObject(clubInfo)">
        <div :class="getCss('club-card-title')" :style="titleFontStyle">
          {{ clubInfo.club_name }}
        </div>
        <div :class="getCss('club-card-content')">
          <div
            ref="target"
            :class="getCss('club-card-target')"
          >
            <div
              ref="targetTest"
              :class="
                isOverflow
                  ? 'bind-club-card-animate club-card-target-text'
                  : 'club-card-target-text'
              "
              :style="targetFontStyle"
            >
              {{ titleOne }}
            </div>
          </div>
          <div
            :class="getCss('club-card-introduce')"
            :style="introduceFontStyle"
          >
            {{ contentOne }}
          </div>
        </div>
        <div
          :class="getCss('club-card-equity')"
          :style="equityFontStyle"
        >
          {{ titleTwo }}
        </div>
      </div>
      <div :class="getCss('club-card-image')">
        <div :class="getCss('message')">
          <div :class="getCss('message-item')">
            <template v-for="(item, index) in platList">
              <span
                :class="getCss('message-test')"
                v-if="item.value === clubInfo.plat"
                :key="index"
                :style="styles.messageStyle"
                >{{ item.label }}</span
              >
            </template>
          </div>
        </div>
        <div :class="getCss('message-image')" :style="messageImageStyle"></div>
      </div>
    </div>
    <div
      v-else
      :class="getCss('no-club-card')"
      :style="noClubCardStyle"
    ></div>
  </div>
</template>
<script>
import "@tencent/ceiba-base-components/index.scss";
import { componentBaseMixin } from "@tencent/ceiba-base-components";
export default {
  name: "CTgclubShowBindClub",
  mixins: [componentBaseMixin],
  data() {
    return {
      cssPrefix: "tgclub-show-bind-club-",
      isShow: true,
      isOverflow: false,
      bindClubId: "",
      clubInfo: {},
      platList: [
        {
          value: 0,
          label: "",
        },
        {
          value: 1,
          label: "微信区",
        },
        {
          value: 2,
          label: "QQ区",
        },
        {
          value: 3,
          label: "全区服",
        },
      ],
    };
  },
  watch: {
    bindClub(value) {
      if (value) {
        this.bindClubId = value;
        this.getClubInfoFlowID();
      }
    },
  },
  computed: {
    titleOne() {
      return this.clubInfo.features[0]?.text.title;
    },
    contentOne() {
      return this.clubInfo?.features[0]?.text.content;
    },
    titleTwo() {
      return this.clubInfo?.features[1]?.text.title;
    },
    //俱乐部名称样式配置
    titleFontStyle() {
      return {
        ...this.styles.titleFontStyle,
        lineHeight: '0.32rem',
      }
    },
    //俱乐部特色一标题样式配置
    targetFontStyle() {
      return {
        ...this.styles.targetFontStyle,
        lineHeight: '0.32rem',
      }
    },
    //俱乐部特色一正文样式配置
    introduceFontStyle() {
      return {
        ...this.styles.introduceFontStyle,
        lineHeight: '0.32rem',
      }
    },
    //俱乐部特色二标题样式配置
    equityFontStyle() {
      return {
        ...this.styles.equityFontStyle,
        lineHeight: '0.4rem',
      }
    },
    isInEditor() {
      return this.$isInEditor;
    },
    // 未绑定俱乐部时卡片整体样式
    noClubCardStyle() {
      const { noBindClubBg } = this.configurationData;
      return {
        backgroundImage: `url(${noBindClubBg})`,
        backgroundSize: "100% 100%",
      };
    },
    // 卡片整体样式
    clubCardStyle() {
      const { BindClubBg } = this.configurationData;
      return {
        backgroundImage: `url(${BindClubBg})`,
        backgroundSize: "100% 100%",
      };
    },
    messageImageStyle() {
      const { club_avatar = '' } = this.clubInfo;
      console.log(club_avatar);
      return {
        backgroundImage: `url(${club_avatar})`,
      };
    },
    fontSize() {
      return this.rootFontSize
        ? parseInt(this.rootFontSize.replace("px", ""), 10)
        : 50;
    },
  },
  async mounted() {
    this.initialize();
    window.addEventListener("resize", this.checkOverflow);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.checkOverflow);
  },
  methods: {
    judgeObject(object) {
      const keys = Object.keys(object);
      return keys.length > 0;
    },
    async initialize() {
      if (this.$isInEditor) {
        this.initClubInfo();
        return;
      }
      this.$onLogined(async () => {
        await this.getClubInfoFlowID();
      });
    },
    initClubInfo() {
      this.clubInfo = {
        club_id: 666,
        club_name: "荣耀殿堂",
        gid: 1333,
        game_name: "合金弹头：觉醒",
        plat: 1,
        os: 1,
        is_cert: 1,
        club_avatar:
          "https://img.xinyue.qq.com/club/6b01ee44fdc0ba5403fc42647c5eeaea_77733d10eccbca78b33f41e9bbd092f0.jpg",
        traceid: "GetClubDetail-1333-666",
        features: [
          {
            text: {
              title: "大神云集、青春回忆",
              content: "内测老人带队，姐妹大大的有",
            },
            image: {
              title: "大神云集、青春回忆",
              content: "内测老人带队，姐妹大大的有",
            },
            video: {
              title: "",
              content: "",
            },
            audio: {
              title: "",
              content: "",
            },
            type: 2,
          },
          {
            text: {
              title: "大神云集",
              content:
                "为大家提供一个忆青春，游戏交流，畅所欲言的平台，只有你想不到，没有我们做不到",
            },
            image: {
              title: "",
              content: "",
            },
            video: {
              title: "",
              content: "",
            },
            audio: {
              title: "",
              content: "",
            },
            type: 1,
          },
        ],
        reword: "1）俱乐部内大佬云集\n2）俱乐部内姐妹多多\n3）俱乐部内福利丰厚",
      };
    },
    async getClubInfoFlowID() {
      const { flowId, gid } = this.configurationData;
      if (!flowId || !this.bindClubId) return;
      const params = {
        gid,
        club_id: this.bindClubId,
      };
      const response = await this.flowRequest({
        flowId,
        params: {
          role: this.roleInfo,
          data: JSON.stringify(params),
        },
      });
      console.log("获取绑定俱乐部详情", JSON.parse(response.data.list));
      const { ret, data } = response;
      if (ret === 0) {
        this.clubInfo = JSON.parse(data.list);
        this.checkOverflow();
      }
    },
    // 判断标题二是否超出范围
    checkOverflow() {
      const that = this;
      this.$nextTick(() => {
        const target = that.$refs.target?.offsetWidth;
        const targetTest = that.$refs.targetTest?.offsetWidth;
        console.log(target, targetTest);
        if (targetTest > target) {
          that.isOverflow = true;
        } else {
          that.isOverflow = false;
        }
      });
    },
  },
};
</script>
<style lang="scss">
@import "./styles.scss";
</style>
